// import create from './simpleCrudServiceFactory';
// export default create('api/config');
import {reqWithToken} from './requestHelper';

export async function getAll() {
    return (await reqWithToken('api/Config')).data;
}

export async function update(update) {
    return (await reqWithToken('api/Config',{
        method: 'put',
        data: update
    })).data;
}

export async function getConfig() {
    return (await reqWithToken('api/Config/getConfig')).data;
}

export async function setPassword(data) {
    return (await reqWithToken('api/Config/setPassword',{
        method: 'put',
        data: data
    })).data;
}